import React, { useEffect } from "react";
import axiosInstance from "../services/AxiosInstance";
import styles from "./css/Case.module.css";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { IonContent, IonHeader, IonPage, IonToolbar, IonTitle } from "@ionic/react";
import ActivityIndicator from "../components/ActivityIndicator";

interface CaseProps extends RouteComponentProps {
    // Define the props here
}

interface Challenge {
    title: string,
    discription: string,
    id: number,
    startDate: string,
    endDate: string
}

interface UserChallenge {
    challenge: Challenge,
    challengeId: number,
    id: number,
    isFinished: boolean,
    userId: number
}

interface MoodQuestion {
    moodQuestion: string,
    questionId: number,
}

interface CaseState {
    disable: boolean,
    challenges: UserChallenge[],
    currentChallengeIsFinished: boolean,
    refreshing: boolean,
    givenChallengeId: number,
    results: string,
    currentChallengeTitle: string,
    currentChallengeDescription: string,
    isLastChallenge: boolean,
    currentUserChallengeId: number,
    subjectHasResults: boolean,
    moodQuestionList: MoodQuestion[],
    userChallengeId: number,
}

class Case extends React.Component<CaseProps, CaseState> {
    constructor(props: CaseProps) {
        super(props);

        this.state = {
            disable: false,
            challenges: [
                {
                    challenge:
                    {
                        title: "",
                        discription: "",
                        id: 0,
                        startDate: new Date().toISOString(),
                        endDate: new Date().toISOString(),
                    },
                    challengeId: 0,
                    id: 0,
                    isFinished: false,
                    userId: 0
                }
            ],
            currentChallengeIsFinished: true,
            refreshing: false,
            givenChallengeId: 0,
            results: "",
            currentChallengeTitle: "",
            currentChallengeDescription: "",
            isLastChallenge: false,
            currentUserChallengeId: 0,
            subjectHasResults: false,
            moodQuestionList: [
                {
                    moodQuestion: "",
                    questionId: 0
                }
            ],
            userChallengeId: 0,
        };
    }

    componentDidMount(): void {
        this.getChallenges();
        this.getResults();
        this.getMoodQuestions();
    }

    async getChallenges() {
        var token = localStorage.getItem("token");
        var id = localStorage.getItem("id");
        var subjectId = localStorage.getItem("subjectId");

        await axiosInstance
            .get(
                "/UserChallenges/" +
                id +
                "/Subjects/" +
                subjectId,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )
            .then((response) => {
                //console.log(response.data)
                let userChallenges: UserChallenge[] = [];
                let newChallenge;
                let now = new Date().toISOString();

                response.data.map((item: UserChallenge) => {
                    if (item.challenge.startDate < now && item.challenge.endDate > now) {
                        newChallenge = {
                            challenge: {
                                title: item.challenge.title,
                                discription: item.challenge.discription,
                                id: item.challenge.id,
                                startDate: item.challenge.startDate,
                                endDate: item.challenge.endDate
                            },
                            challengeId: item.challengeId,
                            id: item.id,
                            isFinished: item.isFinished,
                            userId: item.userId
                        };
                    } else {
                        newChallenge = {
                            challenge: {
                                title: item.challenge.title,
                                discription: item.challenge.discription,
                                id: item.challenge.id,
                                startDate: item.challenge.startDate,
                                endDate: item.challenge.endDate
                            },
                            challengeId: item.challengeId,
                            id: item.id,
                            isFinished: true,
                            userId: item.userId
                        };
                    }
                    userChallenges.push(newChallenge);
                });
                this.setState({ challenges: userChallenges }, () => {
                    this.getNextChallenge();
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    getNextChallenge() {
        var id = localStorage.getItem("id");
        console.log(this.state.challenges)

        for (let i = 0; i < this.state.challenges.length; i++) {
            if (!this.state.challenges[i].isFinished) {
                this.setState({ givenChallengeId: this.state.challenges[i].challengeId });
                this.setState({ currentChallengeTitle: this.state.challenges[i].challenge.title });
                this.setState({ currentChallengeDescription: this.state.challenges[i].challenge.discription });
                this.setState({ currentUserChallengeId: this.state.challenges[i].id });
                this.setState({ currentChallengeIsFinished: false });

                break;
            }
        }
        if (
            this.state.givenChallengeId ==
            this.state.challenges[this.state.challenges.length - 1].challengeId
        ) {
            this.setState({ isLastChallenge: true });
        }
    }


    async getResults() {
        var token = localStorage.getItem("token");
        var id = localStorage.getItem("id");
        var subjectId = localStorage.getItem("subjectId");

        axiosInstance
            .get(
                "/Results/Employee/" + id + "/Subject/" + subjectId,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )

            .then((response) => {
                if (response.data.length == 0) {
                    this.setState({ subjectHasResults: false });
                } else {
                    this.setState({ subjectHasResults: true });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    async getMoodQuestions() {
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");
        let moodQuestions: any[] = []

        axiosInstance
            .get("/MoodQuestions/", {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + token,
                },
            })
            .then((response) => {
                //console.log(response.data);
                response.data.map((question: any) =>
                    moodQuestions.push({
                        moodQuestion: question.question,
                        questionId: question.id
                    })
                );
                //console.log(moodQuestions);

                this.setState({ moodQuestionList: moodQuestions });
                //console.log(this.state.moodQuestionList);
            })
    }


    async goToMoodBeforeQuiz() {

        const { history } = this.props;

        localStorage.setItem("userChallengeId", "" + this.state.currentUserChallengeId)
        localStorage.setItem("isLastMoodQuestion", "" + false)
        localStorage.setItem("isLastChallenge", "" + this.state.isLastChallenge)
        localStorage.setItem("challengeId", "" + this.state.givenChallengeId)
        localStorage.setItem("index", "" + 1)
        localStorage.setItem("score", "" + 0)

        const hasMoodQuestions = this.state.moodQuestionList && this.state.moodQuestionList.length > 0 && this.state.moodQuestionList[0].questionId !== 0;
        if (hasMoodQuestions) {
            localStorage.setItem("moodQuestionList", JSON.stringify(this.state.moodQuestionList))
            localStorage.setItem("moodQuestionIndex", "" + 0)
            localStorage.setItem("isFirstPart", "" + true)
            history.push("/MoodQuestion");
        } else {
            localStorage.setItem("isFirstPart", "" + false)
            history.push("/userStory");
        }
    }

    render() {
        // refresh page to load correct data
        const reloadCount = localStorage.getItem('reloadCount');
        if (reloadCount != null) {
            if (parseInt(reloadCount) < 2) {
                localStorage.setItem('reloadCount', String(reloadCount + 1));
                window.location.reload();
            } else {
                localStorage.removeItem('reloadCount');
            }
        }

        let isFinished = this.state.currentChallengeIsFinished;
        let startChallengeText;
        let disabled = false;
        let iconStartChallenge;

        let results = this.state.subjectHasResults;
        let viewResultsText;
        let noResults = false;

        let done: boolean[] = []
        this.state.challenges.forEach((quiz: any) => {
            done.push(quiz.isFinished)
        })
        let allChallengesDone: boolean = done.every((challenge) => {
            return challenge == true
        })
        //console.log(allChallengesDone)

        if (this.state.challenges.length == 0 || allChallengesDone) {
            isFinished = true;
        }

        disabled = isFinished;

        if (results) {
            noResults = false;
            viewResultsText = "Bekijk hier je resultaten van de vorige quizzen"
        } else {
            noResults = true;
            viewResultsText = "Geen resultaten gevonden"
        }

        if (!disabled) {
            startChallengeText = "Klik hier om de challenge te starten";
            iconStartChallenge =
                (<img
                    className={styles.startIcon}
                    src={require("../assets/icons/challenge.png")}
                />)
        } else {
            startChallengeText =
                "Geen quizzen gevonden";
        }
        return (
            <IonPage>
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                        <button className="backButton" onClick={() => { this.props.history.goBack() }}>&larr;</button>
                        <IonTitle>{localStorage.getItem("subjectName")}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen ion-no-border="true">

                    <div>
                        <div className={styles.layoutChallenge}>
                            <div
                                className={styles.bigButton}
                                onClick={() => { if (!disabled) this.goToMoodBeforeQuiz(); }}
                            >
                                <div
                                    className={disabled ? styles.disabledCasePanel : styles.casePanelChallenge}
                                    style={{ margin: "5%", marginTop: "1vh", marginBottom: "2vh" }}
                                >
                                    <div className={styles.centralize}>
                                        {isFinished ? (
                                            <ActivityIndicator />
                                        ) : (
                                            <>
                                                <h3 className={styles.titel}>
                                                    Quiz: {this.state.currentChallengeTitle}
                                                </h3>
                                            </>
                                        )
                                        }
                                    </div>

                                    <div className={styles.centralize}>
                                        <p className={disabled ? styles.textDisabled : styles.text}>
                                            {startChallengeText}
                                        </p>
                                    </div>
                                    {iconStartChallenge}
                                </div>
                            </div>


                            <div
                                className={styles.bigButton}
                                onClick={() => {
                                    if (!noResults) {
                                        const { history } = this.props;
                                        localStorage.setItem("subjectId", "" + localStorage.getItem("subjectId"))
                                        history.push("/Results");
                                    }
                                }}
                            >
                                <div
                                    className={
                                        noResults ? styles.disabledCasePanel : styles.casePanel
                                    }
                                    style={{ margin: "5%", marginTop: "3vh", marginBottom: "0vh" }}
                                >
                                    <div className={styles.centralize}>
                                        <h3 className={styles.titel}>Resultaten</h3>
                                    </div>

                                    <div className={styles.centralize}>
                                        <p className={noResults ? styles.textDisabled : styles.text}>
                                            {viewResultsText}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={styles.bigButton}
                                onClick={() => {
                                    const { history } = this.props;
                                    history.push("/SubjectFeedback");
                                }}
                            >
                                <div
                                    className={styles.casePanel}
                                    style={{ margin: "5%", marginTop: "3vh" }}
                                >
                                    <div className={styles.centralize}>
                                        <h3 className={styles.titel}>Feedback</h3>
                                    </div>

                                    <div className={styles.centralize}>
                                        <p className={styles.text}>
                                            Klik hier als je feedback wil achterlaten voor dit onderwerp
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(Case);
